import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { trackAddToCartEditEvent } from '@services/ecommerceService';
import { useErrorContext } from '@services/errorService';
import { IGeneralRequestResponse } from '@services/httpClientService';
import { ErrorCodes } from '@utils/constants';

import { createEcommerceProduct } from '../../../ecommerce';
import { errorMessages } from '../../../errorMessages';
import { IProductsUpdateData } from '../../../services';

export const useUpdateItemQuantityCheck = () => {
  const { setErrorState } = useErrorContext();
  const { formatMessage } = useIntl();

  return useCallback(
    (
      updateProductsResponse: IGeneralRequestResponse<IProductsUpdateData> | null,
      productId: number,
      trackingAddToCart: (quantity?: number) => void,
    ): boolean => {
      if (!updateProductsResponse?.data) {
        return false;
      }

      const updatedProduct = updateProductsResponse.data.products.find((el) => el.productId === productId);

      if (!updatedProduct) {
        return false;
      }

      if (!updateProductsResponse.messages.includes(ErrorCodes.SC_EXCEEDED_ITEM_COUNT)) {
        trackingAddToCart();
        return true;
      }

      trackingAddToCart(updatedProduct.count);
      trackAddToCartEditEvent(createEcommerceProduct(updatedProduct), updatedProduct.count);

      setErrorState({
        header: formatMessage(errorMessages.scExceededItemCountHeader, {
          quantity: updatedProduct.count,
        }),
        messages: [
          formatMessage(errorMessages.scExceededItemCountMessage, {
            productName: updatedProduct.name,
            annotation: updatedProduct.annotation,
            quantity: updatedProduct.count,
          }),
        ],
      });

      return false;
    },
    [setErrorState, formatMessage],
  );
};
